export default __webpack_public_path__ + "static/media/google.807f0da4.svg";